module.exports = __webpack_public_path__ + "media/knock02.69963105.mp3";